import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class ScrollContainer extends React.Component {
  constructor(props) {
    super(props);

    // bind
    this.scroll = this.scroll.bind(this);
  }
  componentDidMount() {
    this.scroll(this.props.scrollY);
  }

  componentDidUpdate(nextProps) {
    this.scroll(nextProps.scrollY);
  }

  scroll(y) {
    if (typeof y === 'string') {
      switch (y) {
        case 'end':
        default:
          this.container.scroll(0, this.innerContainer.offsetHeight + 500);
          break;
        case 'start':
          this.container.scroll(0, 0);
          break;
        case 'half':
          this.container.scroll(0, this.innerContainer.offsetHeight / 2);
          break;
      }
    }
  }
  render() {
    const { className, scrollable, scrollY, maxHeight, forwardedRef, ...rest } = this.props;
    const styles = {
      maxHeight: this.props.maxHeight
    };
    return (
      <div
        style={styles}
        className={classNames('overflow-auto', {
          [className]: className
        })}
        ref={node => {
          this.container = node;
          if (typeof forwardedRef === 'function') forwardedRef(node);
        }}
        {...rest}
      >
        <div
          ref={node => {
            this.innerContainer = node;
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => <ScrollContainer {...props} forwardedRef={ref} />)

ScrollContainer.propTypes = {
  scrollable: PropTypes.bool,
  scrollY: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.any,
  className: PropTypes.string,
  maxHeight: PropTypes.number
};

ScrollContainer.defaultProps = {
  scrollable: true,
  scrollY: 0,
  children: null,
  className: '',
  maxHeight: 500
};
